module.exports = __webpack_public_path__ + "static/media/Raspadito del plátano verde.24b920ea.png";